jQuery(window).on("load", function () {
    $('.reviews-block .block').css('opacity', '1');


    $($('.signals-history .currency-wrap .item')[0]).addClass('active')


});

$(document).ready(function () {
    $.validator.setDefaults({
        errorPlacement: function (error, element) {
            return true;
        }
    });

    $('.video-play').click(function () {
        $(this).hide();
        $('.circle-video').hide();
        $('video').trigger('play');
    })

    $('.reviews-block .slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    });

    if ($(window).width() < 1200) {
        var lastScrollTop = 0;
        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            if (st > $(window).height()) {
                $('.fix-menu').addClass('mh-scrolledout');
            } else {
                $('.fix-menu').removeClass('mh-scrolledout');
            }
            if (st > lastScrollTop) {
                $('.fix-menu').addClass('menu-down');
            } else if (st == 0) {
                $('header').removeClass('menu-down');
            } else {
                $('.fix-menu').removeClass('mh-scrolledout');
            }

            lastScrollTop = st;

        });

    } else {
        var heightHeader = $('header .info').height() + 12;
        var lastScrollTop = 0;

        $(window).scroll(function (event) {
            var st = $(this).scrollTop();
            $('header').removeClass('trans');
            if (st > $(window).height()) {
                $('header').addClass('menu-up');
            } else {
                $('header').removeClass('menu-up');
            }
            if (st > heightHeader) {
                $('header').addClass('menu-down');
            } else {
                $('header').removeClass('menu-down');
            }
            if (st < lastScrollTop) {
                $('header').removeClass('menu-up');
            }

            lastScrollTop = st;
        });
    };

    $("#menu").mmenu({
        "extensions": [
                "position-left",
                "pagedim-black",
                "border-offset"
             ],
        classNames: {
            fixedElements: {
                fixed: "fix-menu"
            },
            vertical: "expand"
        }
    });

    $("#menu").mhead();

    if ($('#menu').length > 0) {
        var api = $('#menu').data('mmenu');
        api.bind("close:finish", function () {
            $('.icon').removeClass('open');
        });

        $('#menu a').on('click', function () {
            api.close();
        })
    }

    $('.modal').on('hidden.bs.modal', function (e) {
        $('header').removeClass('open');
    })
    $('.modal').on('show.bs.modal', function (e) {
        if ($('header').hasClass('menu-down')) {
            $('header').addClass('open trans');
        }
    })

    /*
    $('.login-modal-form').validate({
        submitHandler: function (form) {
            $(form).ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    if (data == 'success') {
                        $('.toast-body').css('color', '#28a745');
                        $('.toast-body').text($(form).data('success'));
                        $('.toast').toast('show');
                        $(form).trigger('reset');
                        $('.modal').modal('hide')
                    } else {
                        $('.toast-body').css('color', '#f1202d');
                        $('.toast-body').text($(form).data('error'));
                        $('.toast').toast('show');
                    }
                },
                error: function () {
                    $('.toast-body').css('color', '#f1202d');
                    $('.toast-body').text($(form).data('error'));
                    $('.toast').toast('show');
                }
            });
        }
    });
    */

    function timer() {
        var start = 7; // 10 minutes
        var i = 0;
        var timer = setInterval(function () {
            $('#timing').text(((start - i) % 60));
            i++;

            if (start === i) {
                window.clearInterval(timer);
                //DO STUFF HERE
            }

        }, 1000);
    }

    $('.subscribe-modal form').validate({
        submitHandler: function (form) {
            $(form).ajaxSubmit({
                //clearForm: true,
                success: function (data) {
                    if (data == 'success') {
                        $('.subscribe-modal form').hide();
                        $('.text-paypal').slideDown();
                        //$('.text-paypal .time').show();
                        $(form).trigger('reset');
                        //timer();
                        //setTimeout(function () {
                            //window.location.href = 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=DCGLNZLSHTASQ';
                            window.location.href = 'https://lvmgroup.uk/subscribe';
                            $('.subscribe-modal').modal('hide');
                        //}, 8000)
                    } else {
                        if (data) {
                            $('.subscribe-modal .modal-body').prepend('<div class="alert alert-danger">' + data + '</div>');
                        } else {
                            $('.subscribe-modal .modal-body').prepend('<div class="alert alert-danger">' + $(form).data('error') + '</div>');
                        }

                    }
                    console.log(data);
                },
                error: function () {
                    $('.subscribe-modal .modal-body').prepend('<div class="alert alert-danger">' + $(form).data('error') + ' Send error</div>');
                }
            });
        }
    });

    $('.subscribe-modal').on('hidden.bs.modal', function (e) {
        $('.subscribe-modal form').show();
        $('.text-paypal').hide();
    })

    $('.text-paypal a').click(function () {
        $('.subscribe-modal').modal('hide');
    })

    $('.subscribe-modal').on('hidden.bs.modal', function (e) {
        $('.subscribe-modal form').trigger('reset');
        $('.subscribe-modal .alert-danger').remove();
    });

    $('.map form').validate({
        submitHandler: function (form) {
            $('.map form').ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    if (data == 'success') {
                        $('.toast-body').css('color', '#28a745');
                        $('.toast-body').text($('.map form').data('success'));
                        $('.toast').toast('show');
                        $('.map form').trigger('reset');
                    } else {
                        $('.toast-body').css('color', '#f1202d');
                        $('.toast-body').text($('.map form ').data('error'));
                        $('.toast').toast('show');
                    }
                },
                error: function () {
                    $('.toast-body').css('color', '#f1202d');
                    $('.toast-body').text($('.map form ').data('error'));
                    $('.toast').toast('show');
                }
            });
        }
    });

    $(document).keyup(function (e) {
        if ($('#new-password').val() > 0) {
            $('#confirm-password').attr('required', 'required');
        } else {
            $('#confirm-password').removeAttr('required');
        }
    });

    $('.account-form').validate({
        submitHandler: function (form) {
            if ($('#new-password').val() == $('#confirm-password').val()) {
                $('.text-error-password').addClass('d-none');
                $('.account-form').ajaxSubmit({
                    success: function (data) {
                        console.log(data);
                        var result = data;
                        if (result[0] == 'success') {
                            $('.toast-body').css('color', '#28a745');
                            $('.toast-body').text($('.account-form').data('success'));
                            $('.toast').toast('show');
                            $('.account-form').trigger('reset');
                        } else {
                            $('.toast-body').css('color', '#f1202d');
                            $('.toast-body').text($('.account-form ').data('error'));
                            $('.toast').toast('show');
                        }
                        $('#new-password, #confirm-password').val('');
                        $('#first-name').val(result[1]);
                        $('#email-name').val(result[2]);
                    },
                    error: function () {
                        $('.toast-body').css('color', '#f1202d');
                        $('.toast-body').text($('.account-form ').data('error'));
                        $('.toast').toast('show');
                    }
                });
            } else {
                $('#confirm-password').val('').addClass('error');
                $('.text-error-password').removeClass('d-none');
                setTimeout(function () {
                    $('.text-error-password').addClass('d-none');
                }, 7000)
            }
        }
    });

    $('.signal-modal .btn-danger').on('click', function () {
        $('.signal-modal').hide();
        $('.modal-backdrop').remove();
    })
    $('.modal').on('hidden.bs.modal', function (e) {
        $('.signal-modal').modal('hide');
    })
    $('.scroll').on("click", function (event) {
        var anchor = event.target.hash;
        if (anchor) {
            if ($(anchor).length) {
                event.preventDefault();
                $('body,html').animate({
                    scrollTop: $(anchor).offset().top - 50
                }, 800);
            }
        }
    });

    jQuery(window).scroll(function () {
        var $sections = $('section');
        $sections.each(function (i, el) {
            var top = $(el).offset().top - 40;
            var bottom = top + $(el).height();
            var scroll = $(window).scrollTop();
            var id = $(el).attr('id');
            if (scroll > top && scroll < bottom) {
                $('a.current').removeClass('current');
                $('a[href="#' + id + '"]').addClass('current');

            }
        })
    });

    $('.dropdown-menu p').click(function () {
        $('.dropdown-menu p').removeClass('active');
        $(this).addClass('active');
        var temp = $(this).text();
        $(this).parents('.dropdown').find('span').text(temp);
    })

    $('.history-modal .modal-body .btn').click(function () {
        if ($('.history-modal .modal-body .btn').length > 1) {
            $(this).remove();
            $('.currency .dropdown-menu').append('<p>' + $(this).text() + '</p>');
        } else {
            $(this).remove();
            $('.currency .dropdown-menu').append('<p>' + $(this).text() + '</p>');
            $('.history-modal').modal('hide');
        }
    })

    $('.name-wrap').click(function () {
        $('body').toggleClass('active');
        if ($('body').hasClass('active')) {
            $('.menu-wrap').fadeIn();
        } else {
            $('.menu-wrap').hide();
        }
    })

    if ($(window).width() < 1200) {
        $(document).mouseup(function (e) { // событие клика по веб-документу
            var div = $(".header"); // тут указываем ID элемента
            if (!div.is(e.target) // если клик был не по нашему блоку
                &&
                div.has(e.target).length === 0) { // и не по его дочерним элементам
                $('.menu-wrap').hide();
                $('body').removeClass('active')
            }
        });
    }

    $('.copy').on("click", function (event) {
        tmp = $("<textarea>");
        $("body").append(tmp);
        var text = $(this).parents('.item').find('p').text();
        tmp.val(text).select();
        document.execCommand("copy");
        tmp.remove();
        $(this).attr('data-title', $(this).attr('data-title-end'));
    });

    $(".copy").mouseleave(function () {
        $(this).attr('data-title', $(this).attr('data-title-start'));
    });

    var location = window.location.href;
    var cur_url = location.split('/').pop();
    $('.header ul li').each(function () {
        var link = $(this).find('a').attr('href');

        if (cur_url == link) {
            $(this).find('a').addClass('active');
        }
    });

    $('body').on('click', '.password-control', function () {
        if ($(this).parent().find('input').attr('type') == 'password') {
            $(this).addClass('view');
            $(this).parent().find('input').attr('type', 'text');
        } else {
            $(this).removeClass('view');
            $(this).parent().find('input').attr('type', 'password');
        }
        return false;
    });


    $('.signals-history .currency-wrap').on('click', '.item', function () {
        $('.signals-history .currency-wrap .item').removeClass('active');
        $(this).addClass('active');
    })
    $('.signals-history .date-wrap .item').click(function () {
        $('.signals-history .date-wrap .item').removeClass('active');
        $(this).addClass('active');
    })

    //    $('a[data-toggle="tab"]').on('hide.bs.tab', function (e) {
    //        $('.tab-pane.show .progress-bar').hide();
    //    })
    //
    //    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    //        $('.tab-pane.show .progress-bar').slideDown();
    //    })

    //    var tabsMain = $('.nav-tabs-main li');
    //    var contentMain = $('.tab-content-main>div');
    //    for (var i = 0; i < tabsMain.length; i++) {
    //        $($(tabsMain)[i]).find('a').attr('href', '#tab' + (i + 1));
    //        $($(contentMain)[i]).attr('id', 'tab' + (i + 1));
    //    }
    //
    //    var tabsSecond = $('.tab-content-main>div').find('.nav-link');
    //    var contentSecond = $('.tab-content-main>div').find('.tab-pane');
    //    for (var i = 0; i < tabsSecond.length; i++) {
    //        $($(tabsSecond)[i]).attr('href', '#tab' + (i + tabsMain.length + 1));
    //        $($(contentSecond)[i]).attr('id', 'tab' + (i + tabsMain.length + 1));
    //    }

});
